<div class="multiselect-block" [ngClass]="{'all-customers': selectedCustomers?.length === shortCustomers?.length}">
	<div class="multiselect-label" style="font-size: 90%; color: #b1b1b1;">
		Customers Filter
	</div>

	<p-multiSelect #multiSelect [defaultLabel]="'Customers'" [selectedItemsLabel]="'{0} customers selected'"
		[options]="shortCustomers" styleClass="payment-multiselect" [optionLabel]="'name'"
		[(ngModel)]="selectedCustomers" [showToggleAll]="true" (onChange)="updateCustomers()" [filter]="true"
		[maxSelectedLabels]="1">
<!--		<p-header (click)="showAll()">-->
<!--			Show All-->
<!--		</p-header>-->
	</p-multiSelect>
</div>
